module.exports = __webpack_public_path__ + "9956f7692c72f549e27cf272046dadc4.pdf";